<div *ngIf="headerMapFormGroup != null">
	<form [formGroup]="headerMapFormGroup">
		<div
			*ngFor="let map of expectedHeadersMap"
			fxLayoutAlign="center center"
			style="margin-bottom: 5px"
		>
			<mat-form-field *ngIf="dataType != RFP_UPLOAD_TYPE" fxFlex="50">
				<mat-label
					[ngStyle]="{ color: headerMapFormGroup.controls[map.value].valid ? 'green' : '' }"
					>{{ map.label }}
					<span *ngIf="map.required">*</span>
				</mat-label>
				<mat-select [formControl]="headerMapFormGroup.controls[map.value]">
					<mat-option *ngFor="let header of headersDropdownList" [value]="header.label">
						{{ header.label }}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="headerMapFormGroup.controls[map.value].hasError('required')">
					This field is required
				</mat-error>
			</mat-form-field>
			<div *ngIf="dataType == RFP_UPLOAD_TYPE" fxFlex="25">
				<span [ngStyle]="{ color: headerMapFormGroup.controls[map.value].valid ? 'green' : 'red' }">
					{{ map.value }}
					<span *ngIf="headerMapFormGroup.controls[map.value].hasError('required')">
						: This field is required
					</span>
				</span>
			</div>
		</div>
	</form>
</div>
